// Packages
import { styled } from '@mui/material/styles';
import { TextField } from '@mui/material';

export const StyledInput = styled(TextField, {
  shouldForwardProp: prop => prop !== 'isInvalid',
})(({ theme, isInvalid }) => ({
  width: '350px',
  '& .MuiOutlinedInput-root': {
    height: '31px',
    backgroundColor: theme.palette.primary.transparent,
    borderRadius: theme.shape.customBorderRadius[1],
    '& .MuiOutlinedInput-notchedOutline': {
      border: isInvalid ? `1px solid ${theme.palette.primary.redPrimary}` : `1px solid ${theme.palette.primary.borderGreyPrimary}`,
    },

    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: isInvalid ? `1px solid ${theme.palette.primary.redPrimary}` : `1px solid ${theme.palette.primary.mainHover}`,
    },

    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: isInvalid ? `1px solid ${theme.palette.primary.redPrimary}` : `1px solid ${theme.palette.primary.main}`,
    },
  },
  '& .MuiFormHelperText-root': {
    marginLeft: 0,
    color: isInvalid ? theme.palette.primary.redPrimary : theme.palette.primary.greyPrimary,
    fontSize: '0.75rem',
  },
  // Hide native number spinners (WebKit)
  '& .MuiOutlinedInput-root input[type="number"]::-webkit-outer-spin-button, & .MuiOutlinedInput-root input[type="number"]::-webkit-inner-spin-button': {
    WebkitAppearance: 'none',
    margin: 0,
  },
  // Firefox / generic appearance
  '& .MuiOutlinedInput-root input[type="number"]': {
    MozAppearance: 'textfield',
    appearance: 'textfield',
  },
}));
